import React, {Component} from 'react';
import {Minus, Plus} from 'react-feather';

class CartProduct extends Component{
  addToCart(month) {
    this.props.addQuantity(this.props.product_id, month)
  }

  render() {
    return(
      <div className="CartProduct">
        <div className="Product-bottom">
          <div className="Product-info">
            <p className="Product-title">{this.props.product_title}</p>
            <p className="Product-price">{this.props.product_price}kr</p>
          </div>
          <div className="Product-buttons">
          <div className="Product-quantity-btn">
            <button onClick={() => this.props.reduceQuantity(this.props.product_id, this.props.month)}>
              <Minus />
            </button>
            <span>{this.props.quantity}</span>
            <button onClick={() => this.addToCart(this.props.month)}>
              <Plus />
            </button>
          </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CartProduct;



// WEBPACK FOOTER //
// ./src/components/CartProduct.jsx